module.exports = __webpack_public_path__ + "static/img/payment-paypal.e82e125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-paypal.png
// module id = l1HT
// module chunks = 0